import Http from "./base-http";

class Rule extends Http {
  getRulesList(data) {
    return this.client.get(`/list?companyId=${data.companyId}`)
  }
  addRule(data) {
    return this.client.post(`/`, data)
  }
  updateRule(data){ 
    return this.client.update(`/${data}`)
  }
  deleteRule(data){ 
    return this.client.delete(`/${data}`)
  }
}

const ruleObj = new Rule({
  modelUrlPrefix : "rule"
});

export default ruleObj;
